import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import type { VenueType } from "./types";
import { venueTypeLabelKey } from "./format-venue";

interface VenueTypeBadgeProps {
  readonly type: VenueType;
}

export function VenueTypeBadge({ type }: VenueTypeBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge data-testid={`venue-type-${type}`} variant="outline">
      {t(venueTypeLabelKey(type))}
    </Badge>
  );
}
